export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

export const API_ENDPOINTS = {
    BOOKS: `${API_BASE_URL}/books`,
    BOOKS_BY_ID: (bookId) => `${API_BASE_URL}/books/${bookId}`,
    BOOKS_REFERENCES: `${API_BASE_URL}/books/getReferences`,
    
    COMMENTS: `${API_BASE_URL}/comments`,
    COMMENTS_ALL: `${API_BASE_URL}/comments/all`,
    COMMENTS_BY_BOOK: (bookId) => `${API_BASE_URL}/comments/book/${bookId}`,
    COMMENTS_BY_CHAPTER: (chapterId) => `${API_BASE_URL}/comments/chapter/${chapterId}`,
    COMMENTS_BY_ID_STATE: (commentId) => `${API_BASE_URL}/comments/${commentId}/state`,
    COMMENTS_ALL_DELETED: `${API_BASE_URL}/comments/deleted`,
    
    USERS: `${API_BASE_URL}/users`,
    USERS_EDITORS: `${API_BASE_URL}/users/editors`,
    USERS_REGISTER: `${API_BASE_URL}/users/register`,
    USERS_BY_USERNAME: (username) => `${API_BASE_URL}/users/username/${username}`,
    USERS_PASSWORD_RESET: (token) => `${API_BASE_URL}/users/password/${token}`,
    USERS_BY_ID_ROLE: (userId) => `${API_BASE_URL}/users/${userId}/role`,
    
    CHAPTERS:  `${API_BASE_URL}/chapters`,
    CHAPTERS_OWNED: (flag) =>`${API_BASE_URL}/chapters/owned/${flag}`,
    CHAPTERS_BY_ID: (chapterId) => `${API_BASE_URL}/chapters/${chapterId}`,
    CHAPTERS_TITLES: `${API_BASE_URL}/chapters/titles`,
    CHAPTERS_TAGS: `${API_BASE_URL}/chapters/tags`,
    CHAPTER_FILTER: (keyword, bookId) => `${API_BASE_URL}/chapters/filter?keyword=${encodeURIComponent(keyword)}&bookId=${bookId}`,
    CHAPTERS_SEARCH: (keyword) => `${API_BASE_URL}/chapters/search?keyword=${encodeURIComponent(keyword)}`,
    

    
    TASKS: `${API_BASE_URL}/tasks`,
    TASKS_ASSIGNED: `${API_BASE_URL}/tasks/assigned`,
    TASKS_BY_OWNED_CHAPTERS: `${API_BASE_URL}/tasks/chapters`,
    TASKS_BY_ID_STATE: (taskId) => `${API_BASE_URL}/tasks/${taskId}/state`,
    TASKS_BY_ID_CONTENT: (taskId) => `${API_BASE_URL}/tasks/${taskId}/content`,
    TASKS_BY_CHAPTER: (chapterId) => `${API_BASE_URL}/tasks/chapter/${chapterId}`,
    TASKS_UPDATE_RESPONSIBLE: (taskId) => `${API_BASE_URL}/tasks/${taskId}/responsible`,
    CHAPTER_CONTRIBUITIONS: (chapterId) => `${API_BASE_URL}/tasks/${chapterId}/contribuitions`,
    
    AUTH: `${API_BASE_URL}/auth`,
    AUTH_LOGIN: `${API_BASE_URL}/auth/login`,
    
    PLANTING_TYPES: `${API_BASE_URL}/enums/planting-types`,
    CHAPTERS_SUGESTION_TYPE : `${API_BASE_URL}/enums/chapter-label`,

    // Endpoints para produtos, alinhados com Product.js e ProductList.js
    PRODUCTS_REGISTER: `${API_BASE_URL}/products/register`,
    PRODUCTS_LIST: `${API_BASE_URL}/products`,
    PRODUCTS_DELETE: (productId) => `${API_BASE_URL}/products/${productId}`,
    PRODUCTS_UPDATE: (productId) => `${API_BASE_URL}/products/${productId}`,
    
    // Endpoint para vincular produto a capítulo
    PRODUCT_ATTACH_CHAPTER: (productId, chapterId) => {
        return `${API_BASE_URL}/products/${productId}/chapters/${chapterId}`;
    },

    PRODUCT_UNATTACH_CHAPTER: (productId, chapterId) => {
        return `${API_BASE_URL}/products/${productId}/unattach_chapter/${chapterId}`;
    },

    // Endpoint para obter capítulos vinculados a um produto
    PRODUCT_CHAPTERS: (productId) => `${API_BASE_URL}/products/${productId}/chapters`,
    
    // Endpoint para obter produtos vinculados a um capítulo
    CHAPTER_PRODUCTS: (chapterId) => `${API_BASE_URL}/products/${chapterId}/products`,

    CHAPTER_ACESS_REGISTER : `${API_BASE_URL}/chapterAcess`,
    CHAPTER_ACESS_GET_ALL : `${API_BASE_URL}/chapterAcess/allAcess`,
    CHAPTER_ACESS_FILTER : `${API_BASE_URL}/chapterAcess/filter`,

    RESET_PASSWORD: (url) => `${API_BASE_URL}/email/change-password-email/${url}`,

    NOTIFICATION_BY_USER:  `${API_BASE_URL}/notifications/user`,
    NOTIFICATION_MARK_AS_READ: (notificationId) => `${API_BASE_URL}/notifications/mark-as-read/${notificationId}`,
    NOTIFICATION_MARK_ALL_AS_READ: `${API_BASE_URL}/notifications/mark-all-as-read`,
    NOTIFICATION_UNREAD : `${API_BASE_URL}/notifications/unread`,

    CONFIGS_ALL: `${API_BASE_URL}/configs/all`,
    CONFIGS_UPDATE: (configId) => `${API_BASE_URL}/configs/update/${configId}`,
    CONFIG_SAVE : `${API_BASE_URL}/configs/save`,
    CONFIGS_DELETE: (configId) => `${API_BASE_URL}/configs/delete/${configId}`
};

export const EXTERNAL_API = {
    IBGE_CITIES_BY_STATE: (state) => `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${state}/municipios`
};
